<template>
  <Modal modalType="Expiration" mayCancel="true" v-on:cancel="onOK">
    <h2>This board expires after 7 days</h2>
    <p v-if="!mayClaim && isGuest">
      Boards created by guest users are no longer accessible after seven days
      have passed. To create boards that last longer, create a free account.
    </p>
    <div class="ButtonRow-FlexRight" v-if="!mayClaim && isGuest">
      <button class="WBMBigButton" v-on:click="onOK">Close</button>
      <SignupButton></SignupButton>
    </div>

    <p v-if="!mayClaim && !isGuest">
      Boards created by guest users are no longer accessible after seven days
      have passed. You can add this board to your account and remove the
      expiration date if you have an "Owner" share link, but you do not. Ask the
      board creator for an "Owner" link.
    </p>
    <div class="ButtonRow-FlexRight" v-if="!mayClaim && !isGuest">
      <button class="WBMBigButton" v-on:click="onOK">Close</button>
    </div>

    <p v-if="mayClaim">
      This board was created without a user account, so it will expire after
      seven days have passed since its creation. If you like, you can add it to
      your account and remove the expiration date.
    </p>
    <div class="ButtonRow-FlexRight" v-if="mayClaim">
      <button class="WBMBigButton" v-on:click="onOK">Close</button>
      <a :href="claimURL" class="WBMBigButton m-primary">Claim this board</a>
    </div>
  </Modal>
</template>

<script lang="ts">
import { Component } from "vue-property-decorator";
import Modal from "@/components/Modal.vue";
import SignupButton from "@/components/SignupButton.vue";
import WBComponent from "@/WBComponent";
import { ModalMutations } from "@/store/modules/modal";

@Component({ components: { Modal, SignupButton } })
export default class ExpirationModal extends WBComponent {
  get isOwner(): boolean {
    return this.state.key.accessLevel === "admin";
  }

  get mayClaim(): boolean {
    return this.isOwner && !this.state.user.session.is_guest;
  }

  get isGuest(): boolean {
    return (window as Window).wbconfig?.session?.is_guest;
  }

  get claimURL() {
    return `${location.origin}/whiteboards/${this.state.whiteboard.wbid}/claim?key=${this.state.key.id}`;
  }

  onOK() {
    ModalMutations.closeModals(this.$store.commit);
  }
}
</script>

<style scoped lang="scss">
h2 {
  margin-top: 0;
}
</style>
